<div id="access-background">
    <div id="access-menu">
        <div id="access-menu-header">
            <i class="far fa-sitemap"></i>
            <span>&nbsp;&nbsp;Extended Access</span>
            <span
                (click)="cancelMenu()"
                style="float: right; padding-right: 15px; cursor: pointer;"
            >
                <i class="fas fa-times"></i>
            </span>
        </div>
        <br />
        <p class="section-title">
            <!-- TODO: Add description for extended access -->
        </p>

        <div id="access-menu-body">
            <div style="padding-bottom: 50px;">
                <button
                    type="button"
                    mat-raised-button
                    style="float: right; position: relative; bottom: -18px;"
                    (click)="updateExtendedAccess()"
                >
                    ADD &nbsp;
                    <i class="far fa-plus"></i>
                </button>
            </div>

            <br />

            <table cellpadding="0" cellspacing="0" class="access-table">
                <thead>
                    <tr>
                        <th>Level</th>
                        <th>Entity</th>
                        <th>Employee</th>
                        <th>Delete &nbsp; &nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngIf="
                            extendedAccessLoaded &&
                            (!userExtendedAccess || userExtendedAccess.length == 0)
                        "
                    >
                        <td colspan="4">
                            <div class="no-data-message-area">
                                <no-data-screen [noDataType]="noDataType"></no-data-screen>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="!extendedAccessLoaded || !clientCustomRoles || !levelEntities">
                        <td colspan="4">
                            <spin-loader [type]="'bounce'"></spin-loader>
                        </td>
                    </tr>
                    <ng-container
                        *ngIf="extendedAccessLoaded && clientCustomRoles && levelEntities"
                    >
                        <tr *ngFor="let eAccess of userExtendedAccess">
                            <ng-container *ngIf="eAccess.isPrimaryOwner || eAccess.isDefaultAccess">
                                <td>
                                    {{ eAccess.roleOrder[0].roleName }}
                                </td>
                                <td>
                                    {{ eAccess.hierarchyIdentifier[0].hierarchyName }}
                                </td>
                                <td>
                                    <span *ngIf="!eAccess.employee || eAccess.employee.length < 1"
                                        >All</span
                                    >
                                    <span *ngIf="eAccess.employee && eAccess.employee.length > 0">{{
                                        eAccess.employee[0].lfName
                                    }}</span>
                                </td>
                                <td></td>
                            </ng-container>

                            <ng-container
                                *ngIf="!eAccess.isPrimaryOwner && !eAccess.isDefaultAccess"
                            >
                                <td>
                                    <angular2-multiselect
                                        [data]="clientCustomRoles"
                                        [(ngModel)]="eAccess.roleOrder"
                                        [settings]="roleListSettings"
                                        [disabled]="eAccess.isDeleted"
                                        [ngClass]="{ deleted: eAccess.isDeleted }"
                                        (onSelect)="updateExtendedAccess(eAccess)"
                                    >
                                    </angular2-multiselect>
                                </td>
                                <td>
                                    <angular2-multiselect
                                        [data]="eAccess.entities"
                                        [(ngModel)]="eAccess.hierarchyIdentifier"
                                        [settings]="entityListSettings"
                                        [disabled]="eAccess.isDeleted"
                                        [ngClass]="{ deleted: eAccess.isDeleted }"
                                        (onSelect)="updateExtendedAccess(eAccess)"
                                        (onDeSelect)="updateExtendedAccess(eAccess)"
                                    >
                                    </angular2-multiselect>
                                </td>
                                <td>
                                    <angular2-multiselect
                                        [data]="employees"
                                        [(ngModel)]="eAccess.employee"
                                        [settings]="employeeListSettings"
                                        [disabled]="eAccess.isDeleted"
                                        [ngClass]="{ deleted: eAccess.isDeleted }"
                                        (onSelect)="updateExtendedAccess(eAccess)"
                                        (onDeSelect)="updateExtendedAccess(eAccess)"
                                    >
                                    </angular2-multiselect>
                                </td>
                                <td>
                                    <i
                                        class="far fa-trash"
                                        title="Delete"
                                        (click)="updateExtendedAccess(eAccess, true)"
                                        *ngIf="!eAccess.isDeleted"
                                        style="cursor: pointer;"
                                    ></i>
                                    <i
                                        class="far fa-trash-undo"
                                        title="Undo"
                                        (click)="updateExtendedAccess(eAccess, false)"
                                        *ngIf="eAccess.isDeleted"
                                        style="cursor: pointer;"
                                    ></i>
                                </td>
                            </ng-container>
                        </tr>
                    </ng-container>
                </tbody>
            </table>

            <p
                *ngIf="errors && errors.length > 1"
                style="color: red; font-size: 14px; padding-left: 16px;"
            >
                {{ errors }}
            </p>

            <br />

            <div width="150px" style="float: right; padding-top: 20px;">
                <button mat-button (click)="cancelMenu()">Cancel</button>
                &nbsp;&nbsp;
                <button
                    mat-button
                    primary
                    [disabled]="!canSaveExtendedAccess()"
                    (click)="saveExtendedAccess()"
                >
                    Save &nbsp;
                    <i class="far fa-save"></i>
                </button>
            </div>
        </div>
    </div>
</div>
